import actions from './actions';

const initialState = {
    users: [],
    filteredUsers: [],
    currentUser: null,
    novedades: [],
    novedadesLoading: false,
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_USERS_SUCCESS:
            return {
                ...state,
                users: action.payload,
            }
        case actions.GET_USERS_SUCCESS_QUERY:
            return {
                ...state,
                filteredUsers: action.payload,
            }
        case actions.CREATE_USER_SUCCESS:
            return {
                ...state,
                users: [...state.users, action.payload]
            }
        case actions.EDIT_USER_SUCCESS:
            return {
                ...state,
                users: state.users.map(user => user._id === action.payload._id ? action.payload : user)
            }
        case actions.DELETE_USER_SUCCESS:
            return {
                ...state,
                users: state.users.filter(user => user._id !== action.payload)
            }
        case actions.SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.payload
            }
        case actions.CLEAR_CURRENT_USER:
            return {
                ...state,
                currentUser: null
            }
        case actions.FETCH_NOVEDADES_REQUEST:
            return { ...state, novedadesLoading: true }
        case actions.FETCH_NOVEDADES_SUCCESS:
            return { ...state, novedades: action.payload, novedadesLoading: false }
        case actions.REGISTRAR_NOVEDAD_SUCCESS:
            return { ...state, novedades: [...state.novedades, action.payload] }
        default:
            return state;
    }

}
